import { render, staticRenderFns } from "./TablePermitList.vue?vue&type=template&id=1bf5120c&lang=pug&"
import script from "./TablePermitList.vue?vue&type=script&lang=js&"
export * from "./TablePermitList.vue?vue&type=script&lang=js&"
import style0 from "./TablePermitList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports